import { ListSortItemValue } from '@/shared/models';

export type Sorting = `${ListSortItemValue}`;

export function isSorting(value: unknown): value is Sorting {
  return (
    value === ListSortItemValue.PUBLISHED_AT || value === ListSortItemValue.RATING || value === ListSortItemValue.RANK
  );
}
